/* stylelint-disable color-function-notation */
import styled from 'styled-components';

import { th } from '@yoweb/ui/styles/utils/theme';

const Table = styled.table`
  margin-top: ${th.getSpace('normal1')};
  width: 100%;
`;

export { Table };
export default Table;
